<div class="container">
  <img src="assets/images/gate-card.svg" />
  <div class="title">
    <label>{{ gateName }}</label>
  </div>
  <div class="commands">
    <div class="commands-monitore">
      <button mat-button class="btn-monitore" (click)="motitoreGate()">
        Monitorar
      </button>
    </div>
    <div *ngIf="canEdit" class="commands-edit">
      <input
        type="image"
        src="assets/icons/lapis-edit.svg"
        (click)="editGate()"
      />
    </div>
    <div *ngIf="canEdit" class="commands-remove">
      <input
        type="image"
        src="assets/icons/lixeira2.svg"
        (click)="removeGate()"
      />
    </div>
  </div>
</div>
